import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

/**
 * Gedeelde schil voor de publieke accountpagina's (registreren, verifiëren,
 * wachtwoord vergeten/reset): gecentreerde kaart met logo, titel en subtitel.
 */
@Component({
  selector: 'public-account-shell',
  imports: [LanguageSelectorComponent],
  templateUrl: './public-account-shell.component.html',
  styleUrl: './public-account-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicAccountShellComponent {
  readonly heading = input.required<string>();
  readonly subheading = input<string>('');
}
